import './Header.css'
import React from 'react';
import {useState, useEffect} from 'react';


function Header({items, pagesInView, setPageInView, setCurrentPage}) {
    //const [indicatorOffset, setIndicatorOffset] = useState(0);

    function HeaderButton(props) {
        //let buttonRef = useRef(null);
        const index = props.index;
        return (
            <button onClick={() => {
                setCurrentPage(props.children[1]);
                //setPageInView(index);
                //setIndicatorOffset(buttonRef.current.offsetLeft);
            }} className={"HeaderButton " + (pagesInView[index] ? "HeaderButtonCurrent" : "") }   type='button' >
                {props.children}
            </button>
        );
    }

    let [siteWidth, setSiteWidth] = useState(window.innerWidth);
    useEffect(() => {
        function handleWindowResize() {
            const newSiteWidth = window.innerWidth;
            setSiteWidth(newSiteWidth);
        }
        setSiteWidth(window.innerWidth);

        window.addEventListener('resize', handleWindowResize);
        return () => {
            window.removeEventListener('resize', handleWindowResize);
        };
    }, []);

    return (
        <>
            <div style={{width: "100%", height: "4em"}} />
            <div className="Header" style={{visibility: siteWidth > 600 ? "inherit" : "hidden"}}>
                {items.map((item, index) => <HeaderButton index={index} key={index}>  {item} </HeaderButton>)}
                {/*<div className="HeaderIndicator" style={{left: indicatorOffset}} />*/}
            </div>
        </>
    );
}

export default Header;
